export default __webpack_public_path__ + "static/media/gallery_04.7b766746.jpg";